







import Vue, { PropType } from 'vue'
import UiSeriesBanner from './UiSeriesBanner'
import UiSeriesHeader from './UiSeriesHeader'
import { SeriesInfoData, SeriesInfoImage, SeriesInfoLayout } from './UiSeriesInfo.types'

export default Vue.extend({
  name: 'UiSeriesInfo',
  components: {
    UiSeriesBanner,
    UiSeriesHeader
  },
  props: {
    content: {
      type: Object as PropType<SeriesInfoData>,
      required: true
    },
    image: {
      type: Object as PropType<SeriesInfoImage>,
      default: () => { return {} as SeriesInfoImage }
    },
    warrantyIcon: {
      type: Object as PropType<SeriesInfoImage>,
      default: () => { return {} as SeriesInfoImage }
    },
    layout: {
      type: String as PropType<SeriesInfoLayout>,
      default: 'banner'
    }
  },
  computed: {
    tag (): string {
      const layoutsMap = {
        banner: 'UiSeriesBanner',
        header: 'UiSeriesHeader'
      } as {
        readonly [propName: string]: string
      }
      return layoutsMap[this.layout]
    }
  }
})
